import ModuleContainer from './components/AxpLoyaltyExperienceRoot';

// configure imperatively
import './config/iguazu';

export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x",
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/react-ddl': { version: '0.1.4', module: require('@americanexpress/react-ddl')},
  '@americanexpress/reactlytics': { version: '1.2.7', module: require('@americanexpress/reactlytics')},
  '@emotion/core': { version: '10.3.1', module: require('@emotion/core')},
  'axp-browser-performance-mark': { version: '2.3.0', module: require('axp-browser-performance-mark')},
  'axp-data-manager-utils': { version: '0.3.1', module: require('axp-data-manager-utils')},
  'iguazu': { version: '3.2.0', module: require('iguazu')},
  'iguazu-rpc': { version: '1.6.1', module: require('iguazu-rpc')},
  'react-intl': { version: '5.25.1', module: require('react-intl')},
  },
});

if(global.getTenantRootModule === undefined || (global.rootModuleName && global.rootModuleName === 'axp-loyalty-experience-root')){
global.getTenantRootModule = () => ModuleContainer;
global.rootModuleName = 'axp-loyalty-experience-root';
}
